import { SelectorFakeDataValuePair } from './FakeDataTypes';

/** Changes the value of the input. Takes a pair of "selector" and "value" for the selected node
 *  selector should be of type of the argument of "document.querySelector()"
 *
 *  @see https://developer.mozilla.org/en-US/docs/Web/API/Document/querySelector#examples
 *
 *  !!! For checkbox inputs the value should be "checkbox"
 * */
const triggerInputChange =
  (shouldSubmit: boolean) => (selectorValuePair: SelectorFakeDataValuePair) => {
    const [selector, value] = selectorValuePair;

    const node = document.querySelector(selector);

    if (!node) {
      // eslint-disable-next-line no-console
      console.error(
        `${selector} node was not found. Please check configuration`,
      );
      return;
    }

    // @ts-ignore: No need to add checkbox type check
    if (value === 'checkbox' && !node.checked) {
      // @ts-ignore: Not all Elements are clickable, but checkboxes are.
      node.click();
      return;
    }

    if (shouldSubmit && value === 'button') {
      // Workaround for Submit buttons, changeEvent is not being caught in time if called synchronously
      setTimeout(() => {
        // @ts-ignore: skip redundant check
        node.click();
      }, 1);

      return;
    }

    // @ts-ignore: Muted, no need to check for InputElement to remove the warning
    const setValue = Object.getOwnPropertyDescriptor(
      (node as any).__proto__,
      'value',
    ).set;

    let event: Event;

    // @ts-ignore: Muted, no need to check for InputElement to remove the warning
    if (node.__proto__.constructor === window.HTMLSelectElement) {
      event = new Event('change', {
        bubbles: true,
      });
    } else {
      event = new Event('input', {
        bubbles: true,
      });
    }

    if (typeof value === 'function') {
      // function is used to generate a new value every time button is clicked
      setValue?.call(node, value());
    } else {
      setValue?.call(node, value);
    }

    node.dispatchEvent(event);

    // @ts-ignore
    if (node.__proto__.constructor === window.HTMLSelectElement) {
      // Event is not being dispatched correctly for SELECT element therefore calling it TWICE to register
      setTimeout(() => {
        node.dispatchEvent(event);
      }, 0);
    }
  };

export { triggerInputChange };
